import React, { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { JointBillContext } from "@features/JointBillList/utils";
import { Dropdown } from "@components/Dropdown/Dropdown";
import { IconButton } from "@components/IconButton/IconButton";
import {
  BinIcon,
  ClockIcon,
  DocumentIcon,
  DotsHorizontalIcon,
} from "@components/icons";

interface IRequiredProviderBillOptionsProps {
  isProviderRemoveButtonEnabled?: boolean;
  onRemoveProviderClick?: () => void;
  isOpenPOAButtonEnabled?: boolean;
  onOpenPOAClick?: () => void;
  isProviderHintEnabled?: boolean;
  providerHintText?: string;
}

export const RequiredProviderBillOptions: React.FC<
  IRequiredProviderBillOptionsProps
> = ({
  isProviderRemoveButtonEnabled,
  onRemoveProviderClick,
  isOpenPOAButtonEnabled,
  onOpenPOAClick,
  isProviderHintEnabled,
  providerHintText,
}) => {
  const { t } = useTranslation();
  const { isSummaryMode } = useContext(JointBillContext);

  const dropdownButton = useCallback(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    (props) => <IconButton icon={DotsHorizontalIcon} {...props} />,
    [],
  );

  const dropdownOptions = [
    ...(isProviderHintEnabled && providerHintText
      ? [
          {
            label: providerHintText,
            icon: ClockIcon,
            disabled: true,
            className: "text-base-black",
            iconClassName: "text-base-black",
          },
        ]
      : []),
    ...(isProviderRemoveButtonEnabled
      ? [
          {
            label: t("bill.requestedSp.interactions.remove.label"),
            onClick: onRemoveProviderClick,
            icon: BinIcon,
          },
        ]
      : []),
    ...(isOpenPOAButtonEnabled
      ? [
          {
            label: t("bill.requestedSp.interactions.openPowerOfAttorney.label"),
            onClick: onOpenPOAClick,
            icon: DocumentIcon,
          },
        ]
      : []),
  ];

  return (
    <div className="relative mt-0 gap-0">
      {!isSummaryMode && dropdownOptions.length > 0 && (
        <div className="md:hidden">
          <Dropdown
            buttonAs={dropdownButton}
            options={dropdownOptions}
            placement="bottom-end"
            shouldTruncateOptions={false}
          />
        </div>
      )}
    </div>
  );
};
